/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-subtract-alt': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 110 15 7.5 7.5 0 010-15zm0-1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zM6.25 9.375h7.5v1.25h-7.5v-1.25z"/>'
  }
})
